import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {InsolesProfileModel} from "../../../api/entity/insolesProfile.model";

@Injectable({
    providedIn: 'root'
})
export class InsolesProfileRepository extends AbstractRepositoryV2<InsolesProfileModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsolesProfile', serviceElementsFactory, injector);
    }
}
